<template>
    <div>
        <general-information 
            :tableName="tableName"
            :columnData="columnData"
        >
        </general-information>
    </div>
</template>

<script>
import Vue from 'vue';
import GeneralInformation from '@/components/pages/project/percent_progress/common/tables/general_information.vue';

export default {
    name: 'general_information_other_discipline_equipment',
    components: {
        GeneralInformation,
    },
    data() {
        return {
            tableName: 'progress_other_discipline_equipment_general',
            columnData: [
                {
                    label: Vue.i18n.translate('table.total_value_work_equipment_estimated'),
                    field: 'total_value_work_equipment_estimated',
                },
                {
                    label: Vue.i18n.translate('table.current_execution_value_work_drawings'),
                    field: 'current_execution_value_work_drawings',
                },
                {
                    label: Vue.i18n.translate('table.start_progress_measurement'),
                    field: 'start_progress_measurement',
                },
                {
                    label: Vue.i18n.translate('table.end_progress_measurement'),
                    field: 'end_progress_measurement',
                },
                {
                    label: Vue.i18n.translate('table.total_estimated_hours'),
                    field: 'total_estimated_hours',
                },
                {
                    label: Vue.i18n.translate('table.current_available_hours'),
                    field: 'current_available_hours',
                },
            ],
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/other_discipline/equipment/general_information/general_information_other_discipline_equipment.vue